import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getOrganizationInterop } from '../../../../data/admin'
import { UserFriendlyError } from '../../../../model/Error'
import { isDefined } from '../../../../misc/functions.utilities'
import { organizationInteropKeys } from './organizationInterop.keys'

export const useGetOrganizationInterop = (organizationCode?: string) => {
  const queryKey = useMemo(
    () => organizationInteropKeys.detail(organizationCode),
    [organizationCode],
  )

  const queryReturn = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      if (!isDefined(organizationCode)) return

      const { data, ok } = await getOrganizationInterop(organizationCode, signal)
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de recuperer les donnees de l'organisation`,
          `Organisation ${organizationCode} inaccessible`,
        )
      }
      return data
    },
    enabled: isDefined(organizationCode),
  })

  return queryReturn
}
